import { useEffect } from 'react';

import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { getSessionId } from 'state/amplitude/amplitude-package';
import { RunningExperiments, useExperiments } from 'state/experiments';

import {
  clearMinimalCartExperimentExposureSessions,
  hasHandledMinimalCartExperimentExposureSession,
  markMinimalCartExperimentExposureSessionHandled,
} from './minimal-cart-exposure-sessions';

const MINIMAL_CART_EXPOSURE_DEDUPE_PREFIX = 'amplitude-session:';

export const getMinimalCartExperimentSessionDedupeKey = (sessionId?: string | null) =>
  sessionId ? `${MINIMAL_CART_EXPOSURE_DEDUPE_PREFIX}${sessionId}` : undefined;

export const clearMinimalCartExperimentExposureSessionsForTests = () => {
  clearMinimalCartExperimentExposureSessions();
};

export const useMinimalCartExperimentVariant = () => {
  const { getVariantValue } = useExperiments();

  return getVariantValue(RunningExperiments.EnableMinimalCart)?.value;
};

export const useEnableMinimalCartExperiment = () => {
  const variantValue = useMinimalCartExperimentVariant();
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();

  return variantValue === 'treatment' && isUnifiedMenuEnabled;
};

export const useExposeMinimalCartExperiment = (shouldExpose = true) => {
  const { logExposure } = useExperiments();
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();
  const variantValue = useMinimalCartExperimentVariant();
  const amplitudeSessionId = getSessionId()?.toString();

  useEffect(() => {
    const dedupeKey = getMinimalCartExperimentSessionDedupeKey(amplitudeSessionId);

    if (
      !shouldExpose ||
      !isUnifiedMenuEnabled ||
      !variantValue ||
      !dedupeKey ||
      hasHandledMinimalCartExperimentExposureSession(dedupeKey)
    ) {
      return;
    }

    logExposure(RunningExperiments.EnableMinimalCart, { dedupeKey });
    markMinimalCartExperimentExposureSessionHandled(dedupeKey);
  }, [amplitudeSessionId, isUnifiedMenuEnabled, logExposure, shouldExpose, variantValue]);
};
